// src/components/NavigationDrawer/ScenarioSection/ScenarioListItem.tsx

import React from 'react';
import { ListItemIcon, ListItemText, Tooltip, ListItemButton } from '@mui/material';
import { Link } from 'react-router-dom';
import { ControlCamera, VoiceChat } from '@mui/icons-material';
import clsx from 'clsx';
import { generatePath } from 'react-router';
import AppRoutes from '../../../utils/routes.ts';
import truncateString from './utils/helpers.ts';
import { MENU_ITEM_MAX_CHAR_LENGTH } from './NavigationDrawerScenarioList/constants.ts';
import { useSelector } from 'react-redux';
import { isUserAnyAdminSelector } from '../../../selectors/userSelectors.ts';
import type { ScenarioDto } from '@/api-gen/api.schemas';
import { styled } from '@mui/material/styles';
import { StyledScenarioListItem } from './styles.ts';
import { StyledListItem } from '../styles.ts';

const StyledTooltip = styled(Tooltip)(({ theme }) => ({
  '& .MuiTooltip-tooltip': {
    fontSize: theme.typography.pxToRem(14)
  }
}));

interface ScenarioListItemProps {
  scene: ScenarioDto;
  classes: {
    selected: string;
    withB: string;
    withTBP: string;
    sharedScenario: string;
    subMenuWidth: string;
    white: string;
    black?: string;
    nested?: string;
    subGroupSubMenuWidth?: string;
    rootItem?: string;
  };
  companyId?: number;
  handleRightClick: (event: React.MouseEvent<HTMLElement>, scene: ScenarioDto) => void;
  handleSelectScenario: () => void;
  isSelected: boolean;
  isSubGroupItem?: boolean;
  disableActions?: boolean;
}

const ScenarioListItem: React.FC<ScenarioListItemProps> = React.memo(
  ({
    scene,
    classes,
    companyId,
    handleRightClick,
    handleSelectScenario,
    isSelected,
    isSubGroupItem,
    disableActions
  }) => {
    const isAnyAdmin = useSelector(isUserAnyAdminSelector);
    const path = scene.id ? generatePath(AppRoutes.SceneWithId, { id: scene.id }) : '#';

    const listItemContent = (
      <StyledScenarioListItem
        key={companyId && scene.id ? companyId + scene.id : scene.id}
        onContextMenu={
          disableActions ? undefined : (event: React.MouseEvent<HTMLElement>) => handleRightClick(event, scene)
        }
        data-cy="scenario"
        onClick={handleSelectScenario}
        to={path}
        classes={{ selected: classes.selected }}
        className={clsx(
          classes.withB,
          classes.withTBP,
          isSubGroupItem ? classes.nested : classes.rootItem,
          !scene.companyId && classes.sharedScenario
        )}
        component={Link}
        selected={isSelected}
      >
        <ListItemIcon className={isSubGroupItem ? classes.subGroupSubMenuWidth : classes.subMenuWidth}>
          <VoiceChat
            classes={{ root: classes.black }}
            className={isSubGroupItem ? classes.subGroupSubMenuWidth : classes.subMenuWidth}
          />
        </ListItemIcon>
        <ListItemText primary={truncateString(scene.name || '', MENU_ITEM_MAX_CHAR_LENGTH)} />
      </StyledScenarioListItem>
    );

    return isAnyAdmin && scene.description ? (
      <StyledTooltip title={scene.description} placement="right">
        {listItemContent}
      </StyledTooltip>
    ) : (
      listItemContent
    );
  }
);

ScenarioListItem.displayName = 'ScenarioListItem';

export default ScenarioListItem;
